import { useSyncExternalStore } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebaseConfig';

let state = { policy: null, loading: true, error: '' };
let stop = null;
const listeners = new Set();
function publish(next) { state = next; listeners.forEach(listener => listener()); }
function subscribe(listener) {
    listeners.add(listener);
    if (!stop) stop = onSnapshot(doc(db, 'publishingConfig', 'fees'), snapshot => {
        publish({ policy: snapshot.data() || { version: 0 }, loading: false, error: '' });
    }, error => publish({ policy: null, loading: false, error: error.message || 'Service fees could not be loaded.' }));
    return () => {
        listeners.delete(listener);
        if (!listeners.size && stop) { stop(); stop = null; state = { policy: null, loading: true, error: '' }; }
    };
}
const snapshot = () => state;
export function useServiceFeePolicy() { return useSyncExternalStore(subscribe, snapshot, snapshot); }
